<template>
  <div class="file-box__detail">
    <div
      class="upload-card"
      @click="handleClick"
    >
      <div
        class="add-icon"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'upload-card',
  methods:{
    handleClick(){
      this.$emit('click')
    }
  }
}
</script>

<style scoped lang="scss">
.file-box__detail{
  position: relative;
  display: flex;
  justify-content: flex-end;
}
.upload-card {
  z-index: 0;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 335px;
  height: 200px;
  border: 1px dashed #91939a;
  border-radius: 4px;
  cursor: pointer;
  img {
    max-width: 100%;
    max-height: 100%;
    z-index: 3;
  }
  .add-icon {
    width: 100%;
    height: 100%;
    &::before {
      z-index: -1;
      position: absolute;
      content: "";
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 50px;
      height: 1px;
      background: #979797;
    }
    &::after {
      z-index: -1;
      position: absolute;
      content: "";
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 1px;
      height: 50px;
      background: #979797;
    }
  }
  .upload-btn-box {
    z-index: 4;
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    top: 10px;
    right: 10px;
    width: 36px;
    height: 36px;
    border-radius: 6px;
    background: #012a63;
    cursor: pointer;
    img {
      width: 30px;
      height: 30px;
    }
  }
  &.noBorder{
    border: none;
    height: 100%;
  }
}
</style>
